import { render, staticRenderFns } from "./Forwarder.vue?vue&type=template&id=2ab806f6&"
import script from "./Forwarder.vue?vue&type=script&lang=js&"
export * from "./Forwarder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab806f6')) {
      api.createRecord('2ab806f6', component.options)
    } else {
      api.reload('2ab806f6', component.options)
    }
    module.hot.accept("./Forwarder.vue?vue&type=template&id=2ab806f6&", function () {
      api.rerender('2ab806f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Forwarder.vue"
export default component.exports